import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ReactElement } from 'react';

interface IProps {
  label: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

const AddChipButton = ({ label, onClick, disabled = false }: IProps): ReactElement => {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        userSelect: 'none',
      }}
    >
      <IconButton
        size="small"
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        sx={{
          width: 32,
          height: 32,
          backgroundColor: '#1976d2',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#1565c0',
          },
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '0.9rem',
          color: '#1f1f1f',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default AddChipButton;